// extracted by mini-css-extract-plugin
export default {"phoneNumber":"Recording_phoneNumber__mOwcD"};